<div style="clear: both; height: 10px; display: block; width: 540px;"></div>
<p class="resultsHeading">
    <span [innerHTML]="heading"></span>
</p>
